import React, { useState, useEffect } from "react";

import './styles.css';

import companyServices from "../../../../../services/admFin/companyServices";
import estados_e_cidades from "../../../../../services/estadosECidades";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import Notice from "../../../../../components/Notice";
import SelectBankAccountsPopUp from "./SelectBankAccountsPopUp";
import { FaBuilding, FaRegFolder } from "react-icons/fa";


export default function CompanyPopUp(props) {
    const [nome, setNome] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [razaoSocial, setRazaoSocial] = useState("");
    const [email, setEmail] = useState("");
    const [enviarEmailDestinatario, setEnviarEmailDestinatario] = useState("Sim");
    const [discriminaImpostos, setDiscriminaImpostos] = useState("Sim");
    const [logradouro, setLogradouro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [bairro, setBairro] = useState("");
    const [numero, setNumero] = useState("");
    const [cep, setCep] = useState("");
    const [ddi, setDdi] = useState("");
    const [iso2, setIso2] = useState("");
    const [telefone, setTelefone] = useState("");
    const [isValidNumber, setIsValidNumber] = useState('');
    const [cnpj, setCnpj] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [inscricaoMunicipal, setInscricaoMunicipal] = useState("");
    const [regimeTributario, setRegimeTributario] = useState("");
    const [habilitaNFe, setHabilitaNFe] = useState("Sim");
    const [habilitaNFCe, setHabilitaNFCe] = useState("Sim");
    const [habilitaNFSe, setHabilitaNFSe] = useState("Sim");
    const [CSCNFCeProducao, setCSCNFCeProducao] = useState("");
    const [idTokenNFCeProducao, setIdTokenNFCeProducao] = useState("");
    const [arquivoCertificadoBase64, setArquivoCertificadoBase64] = useState(null);
    // const [nomeArquivoCertificadoBase64, setNomeArquivoCertificadoBase64] = useState("");
    const [notaFiscal, setNotaFiscal] = useState("Não");
    const [senhaCertificado, setSenhaCertificado] = useState("");
    const [moeda, setMoeda] = useState("");

    const [contasBancarias, setContasBancarias] = useState([]);
    const [listaCidades, setListaCidades] = useState([]);
    const [visibility, setVisibility] = useState(false);

    useEffect(() => {
        if (props.empresa && props.bankAccounts && props.bankAccounts.length > 0 && props.empresa.moeda === moeda)
            setBankAccountIndexes(props.empresa, props.bankAccounts);
        else
            setContasBancarias([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moeda, props.empresa]);

    useEffect(() => {
        if (props.empresa && Object.keys(props.empresa).length > 0) {
            console.log(props.empresa)
            setNome(props.empresa.nome);
            setNomeFantasia(props.empresa.nome_fantasia);
            setRazaoSocial(props.empresa.razao_social);
            setEmail(props.empresa.email);
            setEmail(props.empresa.email);
            setEnviarEmailDestinatario(props.empresa.enviar_email_destinatario ? "Sim" : "Não");
            setDiscriminaImpostos(props.empresa.discrimina_impostos ? "Sim" : "Não");
            setLogradouro(props.empresa.logradouro);
            setCidade(props.empresa.cidade);
            setEstado(props.empresa.estado);
            setBairro(props.empresa.bairro);
            setNumero(props.empresa.numero);
            setCep(props.empresa.cep);
            setDdi(props.empresa.ddi ? props.empresa.ddi : "+55");
            setIso2(props.empresa.iso2_ddi ? props.empresa.iso2_ddi : "br");
            setTelefone(props.empresa.telefone);
            setIsValidNumber(true);
            setCnpj(props.empresa.cnpj);
            setInscricaoEstadual(props.empresa.inscricao_estadual);
            setInscricaoMunicipal(props.empresa.inscricao_municipal);
            setRegimeTributario(props.empresa.regime_tributario !== "" ?
                companyServices.regimes_tributarios.find(obj => obj[0] ===  props.empresa.regime_tributario)[1] 
                : "");
            setHabilitaNFe(props.empresa.habilita_nfe  ? "Sim" : "Não");
            setHabilitaNFCe(props.empresa.habilita_nfce  ? "Sim" : "Não");
            setHabilitaNFSe(props.empresa.habilita_nfse  ? "Sim" : "Não");
            setIdTokenNFCeProducao(props.empresa.id_token_nfce_producao);
            setArquivoCertificadoBase64(props.empresa.arquivo_certificado_base64);
            setNotaFiscal(props.empresa.nota_fiscal  ? "Sim" : "Não");

            setSenhaCertificado(props.empresa.senha_certificado);
            setMoeda(props.empresa.moeda);
        }
        if (props.empresa && props.bankAccounts && props.bankAccounts.length > 0)
            setBankAccountIndexes(props.empresa, props.bankAccounts);
    }, [props.empresa, props.bankAccounts]);

    useEffect(() => {
        if (arquivoCertificadoBase64) {
            console.log("Arquivo mudou");
            console.log(arquivoCertificadoBase64.name);
            console.log(arquivoCertificadoBase64);
            // setNomeArquivoCertificadoBase64(arquivoCertificadoBase64.name);
        }
    }, [arquivoCertificadoBase64]);

    useEffect(() => {
        if (estado) {
            const index = estados_e_cidades.estados.findIndex(estadoAux => estado.split(' - ')[0] === estadoAux.sigla)
            if (index !== -1)
                setListaCidades(estados_e_cidades.estados[index].cidades.slice());
            else
                setListaCidades([]);
        }
    }, [estado]);

    function setBankAccountIndexes(company, bankAccounts = []) {
        if (!company || !company.contas_bancarias) return;

        const indexes = [];
        bankAccounts.forEach((obj, index) => {
            company.contas_bancarias.forEach(objAccount => {
                if (objAccount.id === obj.id) {
                    indexes.push(index);
                    return;
                }
            })
        });
        setContasBancarias(indexes);
    }

    function yesOrNoToTrueOrFalse(option) {
        switch (option) {
            case "Sim":
                return true;
            case "Não":
                return false;
            default:
                return undefined;
        }
    }

    return (
        <Popup
            icon={<FaBuilding />}
            tittle={props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <Input
                label="Nome*"
                placeholder="Digite o nome da empresa"
                id="new-company-popup-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <Input
                label="Nome fantasia*"
                placeholder="Digite o nome fantasia da empresa"
                id="new-company-popup-nome-fantasia"
                onChange={(e) => setNomeFantasia(e.target.value)}
                value={nomeFantasia}
            />
            <Input
                label="Razão Social*"
                placeholder="Digite a razão social da empresa"
                id="new-company-popup-razao-social"
                onChange={(e) => setRazaoSocial(e.target.value)}
                value={razaoSocial}
            />

            <Input
                label="E-mail*"
                type="email"
                placeholder="Digite o e-mail da empresa"
                id="new-company-popup-nome-email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
            />


            <div className="line">
                <Input
                    label="CEP*"
                    placeholder="Digite o CEP"
                    id="new-company-popup-cep"
                    onChange={(e) => setCep(String(e.target.value).replace(/\D/g, ''))}
                    value={cep}
                />

                <Input
                    label="Estado*"
                    type="select"
                    options={estados_e_cidades.estados.map((estado) => estado.sigla)}
                    placeholder="Selecione o estado da Empresa"
                    id="new-company-popup-estado"
                    onChange={(e) => setEstado(e.target.value)}
                    value={estado}
                />
            </div>

            <Input
                label="Cidade*"
                type="select"
                // options={estado ? (aux = estados_e_cidades.estados.find(estadoAux => estado.split(' - ')[0] == estadoAux.sigla)) => aux ? aux.cidades : null : null}
                options={listaCidades}
                placeholder={listaCidades.length ? "Selecione a cidade da Empresa" : "Selecione o estado da Empresa primeiro"}
                id="new-company-popup-cidade"
                onChange={(e) => setCidade(e.target.value)}
                value={cidade}
            />

            <Input
                label="Bairro*"
                placeholder="Digite o bairro da Empresa"
                id="new-company-popup-bairro"
                onChange={(e) => setBairro(e.target.value)}
                value={bairro}
            />

            <Input
                label="Logradouro*"
                placeholder="Digite o logradouro da Empresa"
                id="new-company-popup-logradouro"
                onChange={(e) => setLogradouro(e.target.value)}
                value={logradouro}
            />

            <div className="line">
                <Input
                    label="Número residencial*"
                    type="number"
                    placeholder="Digite o número da Empresa"
                    id="new-company-popup-numero"
                    onChange={(e) => setNumero(e.target.value)}
                    value={numero}
                />

                <Input
                    label='Telefone'
                    type='tel'
                    placeholder="Telefone"
                    id='new-company-popup-telefone'
                    onChange={(event) => setTelefone(event.target.value)}
                    iso2={iso2}
                    setIso2={setIso2}
                    setDialCode={setDdi}
                    setIsValidNumber={setIsValidNumber}
                    value={telefone}
                />
            </div>

            <Input
                label="CNPJ*"
                type="number"
                fixLength={14}
                placeholder="Digite o CNPJ da Empresa"
                id="new-company-popup-cnpj"
                onChange={(e) => setCnpj(e.target.value)}
                value={cnpj}
            />
            <Input
                label="Nota fiscal?"
                type='select'
                options={["Sim", "Não"]}
                noFilterOptions
                id='new-company-popup-nota-fiscal'
                onChange={(event) => setNotaFiscal(event.target.value)}
                value={notaFiscal}
            />
            {
                notaFiscal === "Sim" ?
                <>
                    <Input
                        label="Enviar e-mail a destinatário?"
                        type='select'
                        options={["Sim", "Não"]}
                        noFilterOptions
                        id='new-company-popup-enviar-email-destinatario'
                        onChange={(event) => setEnviarEmailDestinatario(event.target.value)}
                        value={enviarEmailDestinatario}
                    />
        
                    <Input
                        label="Discriminar impostos?"
                        type='select'
                        options={["Sim", "Não"]}
                        noFilterOptions
                        id='new-company-popup-discriminar-impostos'
                        onChange={(event) => setDiscriminaImpostos(event.target.value)}
                        value={discriminaImpostos}
                    />
                    <Input
                        label="Inscrição Estadual*"
                        placeholder="Digite o inscrição estadual da Empresa"
                        id="new-company-popup-inscricao-estadual"
                        onChange={(e) => setInscricaoEstadual(String(e.target.value).replace(/\D/g, ''))}
                        value={inscricaoEstadual}
                    />
        
                    <Input
                        label="Inscrição Municipal"
                        placeholder="Digite o inscrição municipal da Empresa"
                        id="new-company-popup-inscricao-municipal"
                        onChange={(e) => setInscricaoMunicipal(String(e.target.value).replace(/\D/g, ''))}
                        value={inscricaoMunicipal}
                    />
        
                    <Input
                        label="Regime tributário*"
                        type='select'
                        options={companyServices.regimes_tributarios.map(item => item[1])}
                        noFilterOptions
                        id='new-company-popup-regime-tributario'
                        onChange={(event) => setRegimeTributario(event.target.value)}
                        value={regimeTributario}
                    />
        
                    <Input
                        label="Habilitar NFe?"
                        type='select'
                        options={["Sim", "Não"]}
                        noFilterOptions
                        id='new-company-popup-habilita-nfe'
                        onChange={(event) => setHabilitaNFe(event.target.value)}
                        value={habilitaNFe}
                    />
        
                    <Input
                        label="Habilitar NFCe?"
                        type='select'
                        options={["Sim", "Não"]}
                        noFilterOptions
                        id='new-company-popup-habilita-nfce'
                        onChange={(event) => setHabilitaNFCe(event.target.value)}
                        value={habilitaNFCe}
                    />
        
                    <Input
                        label="Habilitar NFSe?"
                        type='select'
                        options={["Sim", "Não"]}
                        noFilterOptions
                        id='new-company-popup-habilita-nfse'
                        onChange={(event) => setHabilitaNFSe(event.target.value)}
                        value={habilitaNFSe}
                    />
        
                    <Input
                        label="CSC NFCe"
                        placeholder="Digite o CSC para NFCe"
                        id="new-company-popup-csc-nfce-producao"
                        onChange={(e) => setCSCNFCeProducao(e.target.value)}
                        value={CSCNFCeProducao}
                    />
        
                    <Input
                        label="Id Token NFCe"
                        type="number"
                        placeholder="Digite o id do CSC para NFCe"
                        id="new-company-popup-id-token-nfce-producao"
                        onChange={(e) => setIdTokenNFCeProducao(e.target.value)}
                        value={idTokenNFCeProducao}
                    />
        
                    <Input
                        label="Arquivo Certificado Base 64*"
                        type="file"
                        showFileLabel
                        accept='.pfx'
                        className='new-company-popup-file-input'
                        id="new-company-popup-arquivo-certificado-base64"
                        placeholder={arquivoCertificadoBase64 ? arquivoCertificadoBase64.name : "Selecionar arquivo"}
                        icon={<FaRegFolder />}
                        onChange={(e) => setArquivoCertificadoBase64(e.target.files[0])}
                    />
        
                    <Input
                        label="Senha certificado*"
                        placeholder="Digite a senha do certificado"
                        id="new-company-popup-senha-certificado"
                        onChange={(e) => setSenhaCertificado(e.target.value)}
                        value={senhaCertificado}
                    />
                </>
                :
                null
            }


            <Input
                label="Moeda*"
                type="select"
                noFilterOptions
                options={companyServices.moedaTypes.map(obj => obj[1])}
                placeholder="Selecione a moeda que a empresa trabalha"
                id="new-company-popup-currency"
                onChange={(e) => setMoeda(e.target.value)}
                value={moeda}
            />

            {
                moeda ?
                    !props.bankAccounts || props.bankAccounts.length === 0 ?
                        <Notice>Nenhuma Conta Bancária para selecionar</Notice>
                        :
                        <div className="new-company-popup-button-container">
                            <label className=" input-label new-company-popup-label-bank-accounts">Contas Bancárias</label>
                            <button className="light-blue" onClick={() => setVisibility(true)}>{contasBancarias.length ? `${contasBancarias.length} contas bancárias selecionadas` : "Selecione contas bancárias para ligar à empresa"}</button>
                            <SelectBankAccountsPopUp
                                visibility={visibility}
                                setVisibility={setVisibility}
                                bankAccounts={props.bankAccounts}
                                currency={moeda}
                                contasBancarias={contasBancarias}
                                setContasBancarias={setContasBancarias}
                            />
                        </div>
                    : null
            }

            <button
                onClick={() => {
                    const ids = contasBancarias.map(idx => props.bankAccounts[idx].id);
                    const moedaId = !moeda ? moeda : companyServices.moedaTypes.find(obj => obj[1] === moeda)[0];
                    const regimeTributarioId = !regimeTributario ? regimeTributario : companyServices.regimes_tributarios.find(obj => obj[1] === regimeTributario)[0];
                    props.onClick({
                        nome,
                        nomeFantasia,
                        razaoSocial,
                        email,
                        enviarEmailDestinatario: yesOrNoToTrueOrFalse(enviarEmailDestinatario),
                        discriminaImpostos: yesOrNoToTrueOrFalse(discriminaImpostos),
                        logradouro,
                        cidade,
                        estado: estado ? estado : null,
                        bairro,
                        numero,
                        cep,
                        ddi,
                        iso2,
                        telefone,
                        isValidNumber,
                        cnpj,
                        inscricaoEstadual,
                        inscricaoMunicipal,
                        regimeTributario: regimeTributarioId,
                        habilitaNFe: yesOrNoToTrueOrFalse(habilitaNFe),
                        habilitaNFCe: yesOrNoToTrueOrFalse(habilitaNFCe),
                        habilitaNFSe: yesOrNoToTrueOrFalse(habilitaNFSe),
                        CSCNFCeProducao,
                        idTokenNFCeProducao,
                        arquivoCertificadoBase64,
                        senhaCertificado,
                        nota_fiscal: yesOrNoToTrueOrFalse(notaFiscal),
                        moeda: moedaId,
                        contasBancarias: ids
                    });
                }}
            >{props.buttonTittle}</button>

        </Popup>
    )
}